module.exports = {
      id: "icon_check-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "images/js_src_vue/page_eagle_landing/sprite.b4f41d19.svg#icon_check-usage",
      toString: function () {
        return this.url;
      }
    }